"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const soundController_1 = require("../soundController");
class SceneHelper {
    static switchToMainScreen(scene, data) {
        console.log("here we go again!");
        //SoundController.getInstance().sound = scene.sound; todo CHECK IF THIS KILLS US
        scene.start('MainScene', data);
        scene.stop('LoadingScene');
        scene.dump();
    }
    static switchToTutorialScene(game) {
        game.scene.manager.stop("MenuScene");
        game.scene.manager.start("IntroScene");
        game.scene.manager.dump();
    }
    static switchToCreditScene(game) {
        game.scene.manager.stop("MenuScene");
        game.scene.manager.start("CreditScene");
        game.scene.manager.dump();
    }
    static switchToMenuScene(game) {
        game.scene.manager.stop("CreditScene");
        game.scene.manager.start("MenuScene");
        game.scene.manager.dump();
    }
    static transitionScene(game, sceneKey) {
        console.log("here we go again for " + sceneKey.getKey());
        soundController_1.SoundController.getInstance().sound = game.sound;
        game.scene.manager.stop("MenuScene");
        game.scene.manager.stop("RacoonScene");
        game.scene.manager.stop('MainScene');
        game.scene.manager.start('LoadingScene', sceneKey);
        game.scene.manager.dump();
    }
    static steeringScene(game, sceneKey) {
        console.log("Steering scene ", sceneKey);
        game.scene.manager.stop('MainScene');
        game.scene.manager.dump();
        game.scene.manager.start('SteeringWheelScene', sceneKey);
        game.scene.manager.dump();
    }
    static switchToRaccoonScene(game, sceneLoadingData) {
        game.scene.manager.stop('MainScene');
        game.scene.manager.start('RacoonScene', sceneLoadingData);
    }
}
exports.SceneHelper = SceneHelper;
